<section class="user-details">
  <header>
    <div>
      <h1>Détail utilisateur</h1>
      <p>Profil complet, rôle et indicateurs d’activité.</p>
    </div>
    <a routerLink="/dashboard/users" class="ghost">Retour à la liste</a>
  </header>

  <div class="state loading-state" *ngIf="loading">
    <span class="spinner" aria-hidden="true"></span>
    <span>Chargement…</span>
  </div>
  <p class="message error" *ngIf="!loading && errorMessage">{{ errorMessage }}</p>

  <ng-container *ngIf="!loading && user">
    <section class="panel identity">
      <h2>{{ displayName() }}</h2>
      <p>{{ user.email }}</p>
      <div class="badges">
        <span>{{ user.role || 'USER' }}</span>
        <span [class.disabled]="user.enabled === false">{{ user.enabled === false ? 'Désactivé' : 'Actif' }}</span>
        <span *ngIf="user.isEmailVerified">Email vérifié</span>
      </div>
    </section>

    <section class="panel details">
      <h3>Informations</h3>
      <dl>
        <div>
          <dt>ID utilisateur</dt>
          <dd>{{ user.id }}</dd>
        </div>
        <div>
          <dt>ID membre</dt>
          <dd>{{ user.member?.id || '-' }}</dd>
        </div>
        <div>
          <dt>Téléphone</dt>
          <dd>{{ user.member?.phoneNumber || '-' }}</dd>
        </div>
        <div>
          <dt>Genre</dt>
          <dd>{{ user.member?.gender || '-' }}</dd>
        </div>
        <div>
          <dt>Date de naissance</dt>
          <dd>{{ user.member?.birthDate || '-' }}</dd>
        </div>
      </dl>
    </section>

    <section class="panel details">
      <h3>Bio et adresse</h3>
      <p>{{ user.member?.biography || 'Aucune biographie' }}</p>
      <dl>
        <div>
          <dt>Rue</dt>
          <dd>{{ user.member?.address?.street || '-' }}</dd>
        </div>
        <div>
          <dt>Ville</dt>
          <dd>{{ user.member?.address?.city || '-' }}</dd>
        </div>
        <div>
          <dt>Pays</dt>
          <dd>{{ user.member?.address?.country || '-' }}</dd>
        </div>
      </dl>
    </section>

    <section class="panel stats" *ngIf="stats">
      <h3>Statistiques</h3>
      <div class="stats-grid">
        <article>
          <strong>{{ stats.followersCount ?? 0 }}</strong>
          <span>Followers</span>
        </article>
        <article>
          <strong>{{ stats.followingsCount ?? 0 }}</strong>
          <span>Abonnements</span>
        </article>
        <article>
          <strong>{{ stats.recipesCount ?? 0 }}</strong>
          <span>Recettes publiées</span>
        </article>
        <article>
          <strong>{{ stats.recipesSoldCount ?? 0 }}</strong>
          <span>Recettes vendues</span>
        </article>
      </div>
    </section>
  </ng-container>
</section>
